/*
 * File: \src\service\data-rangers\src\config.js
 * Created Date: 2020-11-05 09:14:51
 * Author: gaozw
 * -----
 * Last Modified: 2021-06-22 10:48:54 am
 * Modified By: huangxl (huangxl20@meicloud.com)
 */
import Config from '@/config'

const initConfig = {
    app_id: Config.dataRangers_appId,//  必须替换成申请的 app_id
}
export default { initConfig }
